import {ComponentProps, FunctionComponent} from 'react';
import {useTranslation} from 'react-i18next';

export const MaxButton: FunctionComponent<ComponentProps<'button'>> = ({className, onClick, ...rest}) => {
  const {t} = useTranslation('translation');

  return (
    <button
      className={`flex p-2 gap-2 justify-center items-center text-white rounded-xl bg-blue-700 hover:opacity-70 disabled:grayscale disabled:opacity-100 ${className}`}
      onClick={onClick}
      {...rest}
    >
      <span>{t('actions.max')}</span>

      <span className='w-[1px] h-6 bg-gray-500' />

      <span className='w-4 aspect-square'>{t('symbols.arrowUp')}</span>
    </button>
  );
};
